"use strict";

var _classCallCheck = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/runner/work/react-nexys-boilerplate/react-nexys-boilerplate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var wrapComponent = function wrapComponent() {
  return function (WrappedComponent) {
    return /*#__PURE__*/function (_react_1$default$Comp) {
      _inherits(Hoc, _react_1$default$Comp);

      var _super = _createSuper(Hoc);

      function Hoc(props) {
        var _this;

        _classCallCheck(this, Hoc);

        _this = _super.call(this, props);
        _this.state = {
          name: _this.props.name,
          value: _this.props.value,
          rows: _this.props.rows ? _this.props.rows : 1
        };
        _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
        _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
        return _this;
      }

      _createClass(Hoc, [{
        key: "handleChange",
        value: function handleChange(event) {
          var newValue = event.target.value;
          this.setState({
            value: newValue
          });
          this.props.onChange({
            name: this.state.name,
            value: newValue
          });
        }
      }, {
        key: "handleBlur",
        value: function handleBlur() {
          var nValue = this.state.value;
          this.setState({
            value: nValue
          });

          if (typeof this.props.onBlur !== 'undefined') {
            this.props.onBlur({
              name: this.state.name,
              value: nValue
            });
          }
        }
      }, {
        key: "UNSAFE_componentWillReceiveProps",
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
          this.setState({
            value: nextProps.value
          });
        }
      }, {
        key: "render",
        value: function render() {
          return react_1.default.createElement(WrappedComponent, {
            value: this.state.value,
            onChange: this.handleChange,
            onBlur: this.handleBlur,
            rows: this.state.rows,
            cols: this.props.cols,
            placeholder: this.props.placeholder,
            disabled: this.props.disabled
          });
        }
      }]);

      return Hoc;
    }(react_1.default.Component);
  };
};

exports.default = wrapComponent;